/** @format */

import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const ToastNotification = ({ message, show, onClose }) => {
  return (
    <ToastContainer position="top-end" className="p-3 mt-4">
      <Toast onClose={onClose} show={show} delay={3000} autohide>
        <Toast.Header>
          <strong className="me-auto">Notification</strong>
          <small>Just now</small>
        </Toast.Header>
        <Toast.Body className="h6">{message}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default ToastNotification;
